// Third Party
import React from 'react';

// Components
import DefaultModal from './DefaultModal';

// Constants and types
import ComparisonItem from '@/types/comparison-item';

// Utils
import { formatMessage, FormattedMessage, formatLocalizedString } from '@/utils/i18n';
import { MODAL_SIZES } from '@/utils/constants';

type Props = {
  items: ComparisonItem[];
  show: boolean;
  isConverting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const MixedCurrencyModal = ({ items, show, isConverting, onConfirm, onCancel }: Props) => {
  const getModalBody = () => (
    <>
      <FormattedMessage tagName="p" id="Comparison.MixedCurrency.Modal.BodyTop" />
      <ul className="items-list">
        {items.map(item => (
          <li key={item._id}>{formatLocalizedString(item.name)}</li>
        ))}
      </ul>
      <FormattedMessage tagName="p" id="Comparison.MixedCurrency.Modal.BodyBottom" />
    </>
  );

  return (
    <DefaultModal
      title={
        <span>
          <i className="icon-ds-warning-amber" />
          {formatMessage('Comparison.MixedCurrency.Modal.Title')}
        </span>
      }
      confirmLabel={formatMessage('Comparison.MixedCurrency.Modal.ConfirmLabel')}
      onCancel={onCancel}
      onConfirm={onConfirm}
      show={show}
      body={getModalBody()}
      onSecondaryAction={onCancel}
      secondaryActionLabel={formatMessage('Comparison.MixedCurrency.Modal.SecondaryActionLabel')}
      className="mixed-currency-modal"
      size={MODAL_SIZES.LG}
      isSubmitting={isConverting}
      actionsInverted
      hideCancelButton
    />
  );
};

export default MixedCurrencyModal;
